import { put, call, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import client from '../client';
import { certificatesActions } from '../reducers/certificates';
import { LoadCertificatesListAction, RevokeCSRAction, UploadCSRAction } from '../actionTypes/certificates';
import { ICertificate } from '../models/certificates';

export function* loadCertificates({ payload: { res, rej } }: PayloadAction<LoadCertificatesListAction>) {
  try {
    const response: ICertificate[] = yield call(client, { url: 'certificate/list' });
    yield put(certificatesActions.loadCertificatesSuccess(response));
    if (typeof res === 'function') {
      yield call(res);
    }
  } catch (err: any) {
    yield put(certificatesActions.loadCertificatesFail(err));
    if (typeof rej === 'function') {
      yield call(rej);
    }
  }
}

export function* uploadCSR({ payload: { attachments, res, rej } }: PayloadAction<UploadCSRAction>) {
  try {
    const response: ICertificate = yield call(client, {
      url: 'certificate/upload',
      attachments,
      method: 'POST',
    });
    yield put(certificatesActions.uploadCSRSuccess(response));
    if (typeof res === 'function') {
      yield call(res);
    }
  } catch (error: any) {
    yield put(certificatesActions.uploadCSRFail(error));
    if (typeof rej === 'function') {
      yield call(rej, error);
    }
  }
}

export function* revokeCSR({ payload: { id, res, rej } }: PayloadAction<RevokeCSRAction>) {
  try {
    yield call(client, {
      url: `certificate/revoke/${id}`,
      method: 'POST',
    });
    yield put(certificatesActions.revokeCSRSuccess({ id }));
    if (typeof res === 'function') {
      yield call(res);
    }
  } catch (error: any) {
    yield put(certificatesActions.revokeCSRFail(error));
    if (typeof rej === 'function') {
      yield call(rej, error);
    }
  }
}

export default function* certificatesSaga() {
  yield takeLatest(certificatesActions.loadCertificates.type, loadCertificates);
  yield takeLatest(certificatesActions.uploadCSR.type, uploadCSR);
  yield takeLatest(certificatesActions.revokeCSR.type, revokeCSR);
}
